import { coreDefaultTheme, DottedProgressTheme } from '@kite-js/theme';
import colors from '../colors';

const dottedProgressTheme: DottedProgressTheme = {
    ...coreDefaultTheme.dottedProgress,
    dotColors: [
        colors.background[200],
        colors.background[200],
        colors.background[200],
        colors.background[200],
        colors.background[200],
    ],
};

export default dottedProgressTheme;
